import { Box, Typography } from '@mui/material';
import useTitle from '../../../hooks/useTitle';

export default function Imprint() {
  useTitle('Impressum');
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        minHeight: 'calc(100vh - 94px)',
        alignItems: 'center',
        justifyContent: 'center',
        py: '100px',
      }}
    >
      <Box sx={{ maxWidth: '80%', width: '700px' }}>
        <Typography sx={{ mt: '14px', fontSize: '36px' }}>Impressum</Typography>
        <Typography sx={{ mt: '14px' }}>
          Codemeta GmbH
          <br />
          Daimlerstr. 22a
          <br />
          54634 Bitburg
        </Typography>
        <Typography sx={{ mt: '14px' }}>
          Handelsregister: HRB 47087
          <br />
          Registergericht: Amtsgericht Wittlich
          <br />
        </Typography>
        <Typography sx={{ mt: '14px' }}>
          Vertreten durch: Moritz und Sven Lübken
        </Typography>
        <Typography sx={{ mt: '14px', fontSize: '24px' }}>
          Umsatzsteuer-ID
        </Typography>
        <Typography sx={{ mt: '14px' }}>
          Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:
          <br />
          DE369850451
        </Typography>
        <Typography sx={{ mt: '14px', fontSize: '24px' }}>Kontakt</Typography>
        <Typography sx={{ mt: '14px' }}>
          Telefon: <a href="tel:+49 6561 6994420">+49 6561 6994420</a>
          <br />
          E-Mail: <a href="mailto:info@codemeta.de">info@codemeta.de</a>
        </Typography>
        <Typography sx={{ mt: '14px', fontSize: '24px' }}>
          EU-Streitschlichtung
        </Typography>
        <Typography sx={{ mt: '14px' }}>
          Die Europäische Kommission stellt eine Plattform zur
          Online-Streitbeilegung (OS) bereit:{' '}
          <a
            href="https://ec.europa.eu/consumers/odr/"
            target="_blank"
            rel="noreferrer"
          >
            https://ec.europa.eu/consumers/odr/
          </a>
          . Unsere E-Mail-Adresse finden Sie oben im Impressum.
        </Typography>
        <Typography sx={{ mt: '14px', fontSize: '24px' }}>
          Verbraucherstreitbeilegung/Universalschlichtungsstelle
        </Typography>
        <Typography sx={{ mt: '14px' }}>
          Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren
          vor einer Verbraucherschlichtungsstelle teilzunehmen.
        </Typography>
        <Typography sx={{ mt: '14px', fontSize: '24px' }}>
          Zentrale Kontaktstelle nach dem Digital Services Act - DSA (Verordnung
          (EU) 2022/265)
        </Typography>
        <Typography sx={{ mt: '14px' }}>
          Unsere zentrale Kontaktstelle für Nutzer und Behörden nach Art. 11, 12
          DSA erreichen Sie wie folgt:
        </Typography>
        <Typography sx={{ mt: '4px' }}>
          Telefon: <a href="tel:+49 6561 6994420">+49 6561 6994420</a>
          <br />
          E-Mail: <a href="mailto:info@codemeta.de">info@codemeta.de</a>
        </Typography>
        <Typography sx={{ mt: '4px' }}>
          Die für den Kontakt zur Verfügung stehenden Sprachen sind: Deutsch,
          Englisch
        </Typography>
        <Typography sx={{ mt: '14px' }}>
          Quelle:{' '}
          <a
            href="https://www.e-recht24.de/impressum-generator.html"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://www.e-recht24.de/impressum-generator.html
          </a>
        </Typography>
      </Box>
    </Box>
  );
}
